export default function checkMissingLocale(string: string): string {
  return string === 'Missing locale' ? '' : string;
}
